/**
 * Type definitions for Business Listing domain
 */
import { BaseType } from "./__base__";

export interface Business extends BaseType {
    name: string;
    description: string;
    contact: string;
    address: string;
    postcode: string;
    email: string;
    owner: string;
    user_owner: string | null; // Foreign key to User

    // Optional fields
    logo?: string;
    banner?: string;
    website?: string;
    facebook?: string;
    instagram?: string;
    twitter?: string;
    youtube?: string;

    // Rating
    google_rating?: number;
    google_reviews_count?: number;
    google_reviews_url?: string;

    trustpilot_rating?: number;
    trustpilot_reviews_count?: number;
    trustpilot_reviews_url?: string;
}

export enum ListingType {
    FREE = 'free',
    PAID = 'paid',
    TRIAL = 'trial',
}

export enum ListingStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
}

export interface ListingPolicy extends BaseType {
    business_id: number; // Foreign key to Business
    listing_type: ListingType;
    listing_status: ListingStatus;
    valid_from: string; // ISO string for datetime
    valid_to: string | null;   // ISO string for datetime, null if never expires
    never_expires: boolean;
}

export interface PricingPolicy extends BaseType {
    business_id: number; // Foreign key to Business
    price: number;
    currency: string;
    valid_from: string; // ISO string for datetime
    valid_to: string;   // ISO string for datetime
}

export interface ServiceLocation extends BaseType {
    business_id: number; // Foreign key to Business
    country: number; // Foreign key to Country
    city?: number | null; // Foreign key to City, optional
}

export interface City extends BaseType {
    name: string;
    country_id: number; // Foreign key to Country
}

export interface Country extends BaseType {
    name: string;
}

export enum MinimumOrderType {
    AMOUNT = 'amount',
    PER_KG = 'per_kg',
}

export interface ShippingPolicy extends BaseType {
    business_id: number; // Foreign key to Business
    from_country: number; // Foreign key to Country
    to_country: number; // Foreign key to Country

    // Pricings
    minimum_order_type: MinimumOrderType;
    minimum_order_amount?: number;
    minimum_per_kg_price?: number;
    currency: string;
}


export interface Review extends BaseType {
    business_id: number; // Foreign key to Business
    rating: number;
    comment: string;
}